import request from '@/utils/request'
import { globalHeaders } from '@/utils/request';

//初始化state
const state = {
}
  
  //定义getter
  const getters = {
    
  }

  //定义同步的操作，即mutation
const mutations = {
    
}

//定义异步的操作，即action
const actions = {
    /**
     * @description 删除OSS对象存储
     * @return {Promise}
     */
    // eslint-disable-next-line no-unused-vars
    async delOss({ commit }, {ossId}) {
        let url = `/resource/oss/${ossId}`;
        const result = await request.delete(url);
        return result;
    },

    // 查询OSS对象基于id串
    // async listByIds({ commit },{ossId}){
    //     let url = `/resource/oss/listByIds/${ossId}`;
    //     const result = await request.get(url);
    //     return result;
    // }
    async ossDownload({ commit },{ossId}) {
        const url = '/resource/oss/download/' + ossId;
        try {
            const res = await request.get(url,{
                method: 'get',
                url: url,
                responseType: 'blob',
                headers: globalHeaders()
            });
            return res;
        } catch (r) {
            console.error(r);
        }
    },
    async getOssDetail({ commit },{ossId}) {
        const url = '/resource/oss/' + ossId;
        try {
            const res = await request.get(url,{
                method: 'get',
                url: url
            });
            return res;
        } catch (r) {
            console.error(r);
        }
    }
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }